import Icon from '../components/Icon.vue'

Icon.register({
  capsules: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M555.3 300.1c36.2 51.7 23.7 123-28 159.2-20 14-42.8 20.7-65.5 20.7-36.1 0-71.6-17-93.8-48.8l-131.2-187.3c-5.5-7.9-9.5-16.4-12.8-25v149.1c0 61.9-50.1 112-112 112s-112-50.1-112-112v-224c0-61.9 50.1-112 112-112 60 0 108.5 47.2 111.4 106.5 7.8-21 21.8-40 41.5-53.8 20-14 42.9-20.7 65.5-20.7 36 0 71.5 17 93.8 48.8zM160 256v-112c0-26.5-21.5-48-48-48s-48 21.5-48 48v112h96zM354.8 300.9l82.5-57.7-65.6-93.7c-9.4-13.5-24.8-21.5-41.3-21.5-10.3 0-20.3 3.1-28.8 9.1-11 7.7-18.4 19.3-20.7 32.5-2.4 13.2 0.6 26.6 8.3 37.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/capsules.js
// module id = null
// module chunks = 